// extracted by mini-css-extract-plugin
export default {"form":"ujZRVAml","mobile":"mobile","row":"Lwg0mBg9","field":"imaPJerf","footer":"WMtYD2Ar"};